/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { AvatarsControllerRedirectToAvatarQueryResponse, AvatarsControllerRedirectToAvatarPathParams } from "../../models/avatarsController/AvatarsControllerRedirectToAvatar";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { avatarsControllerRedirectToAvatar } from "../../clients/avatarsService/avatarsControllerRedirectToAvatar";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const avatarsControllerRedirectToAvatarQueryKey = (id: AvatarsControllerRedirectToAvatarPathParams["id"]) => [{
  url: '/api/v1/avatars/:id',
  params: {
    id: id
  }
}] as const;
export type AvatarsControllerRedirectToAvatarQueryKey = ReturnType<typeof avatarsControllerRedirectToAvatarQueryKey>;
export function avatarsControllerRedirectToAvatarQueryOptions(id: AvatarsControllerRedirectToAvatarPathParams["id"], config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = avatarsControllerRedirectToAvatarQueryKey(id);
  return queryOptions<AvatarsControllerRedirectToAvatarQueryResponse, ResponseErrorConfig<Error>, AvatarsControllerRedirectToAvatarQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return avatarsControllerRedirectToAvatar(id, config);
    }
  });
}

/**
 * @summary Redirect to a user avatar image (public; id is a principal or user id)
 * {@link /api/v1/avatars/:id}
 */
export function useAvatarsControllerRedirectToAvatar<TData = AvatarsControllerRedirectToAvatarQueryResponse, TQueryData = AvatarsControllerRedirectToAvatarQueryResponse, TQueryKey extends QueryKey = AvatarsControllerRedirectToAvatarQueryKey>(id: AvatarsControllerRedirectToAvatarPathParams["id"], options: {
  query?: Partial<QueryObserverOptions<AvatarsControllerRedirectToAvatarQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? avatarsControllerRedirectToAvatarQueryKey(id);
  const query = useQuery({
    ...avatarsControllerRedirectToAvatarQueryOptions(id, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}